import React from 'react';
import { Link } from 'react-router-dom';
import { KeyRound, GraduationCap, BookOpen, MessageSquare, Building2, ArrowRight } from 'lucide-react';

const PATHS = [
  {
    id: 'families', title: 'For families',
    items: [
      { to: '/access', Icon: KeyRound, name: 'N3URO ACCESS', cta: 'Create a Free Access Profile', tone: '#5BE9FF' },
      { to: '/academy', Icon: GraduationCap, name: 'N3URO Academy', cta: 'Explore Academy pathways', tone: '#FFB166' },
      { to: '/knowledge', Icon: BookOpen, name: 'N3UROPEDIA Knowledge', cta: 'Explore the A–Z', tone: '#C77DFF' },
    ],
  },
  {
    id: 'organisations', title: 'For organisations',
    items: [
      { to: '/advisory', Icon: MessageSquare, name: 'N3URO Advisory', cta: 'Request a Discovery Session', tone: '#FF6BD5' },
      { to: '/developers-partners', Icon: Building2, name: 'Developers & Partners', cta: 'Start a partnership enquiry', tone: '#FFE066' },
    ],
  },
];

// Homepage gateway into the N3URO WORLD® infrastructure ecosystem — one distinct CTA per pathway.
export const PathwayGateway = () => (
  <section className="pathway-gateway" aria-labelledby="pathway-heading" data-testid="home-pathway-gateway">
    <h2 id="pathway-heading" className="pathway-title">Choose your pathway</h2>
    <div className="pathway-groups">
      {PATHS.map((g) => (
        <div key={g.id} className="pathway-group" data-testid={`pathway-group-${g.id}`}>
          <h3>{g.title}</h3>
          <ul>
            {g.items.map(({ to, Icon, name, cta, tone }) => (
              <li key={to}>
                <Link to={to} className="pathway-card" style={{ '--tone': tone }} data-cta={`home-gateway-${to.replace(/\//g, '')}`} data-testid={`pathway-${to.replace(/\//g, '')}`}>
                  <span className="pathway-icon" aria-hidden="true"><Icon size={20} strokeWidth={1.8} /></span>
                  <span className="pathway-text">
                    <strong>{name}</strong>
                    <span>{cta} <ArrowRight size={13} strokeWidth={2.4} aria-hidden="true" /></span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </section>
);

export default PathwayGateway;
